import type { AgentStatusEventPayload } from '../types/agentStatus.types'

export function parseAgentStatusEvent(raw: unknown): AgentStatusEventPayload | null {
  if (raw === null || typeof raw !== 'object' || Array.isArray(raw)) return null

  const payload = raw as Record<string, unknown>
  if (payload.type !== 'agent_status') return null

  const requestId = typeof payload.requestId === 'string' ? payload.requestId.trim() : ''
  if (!requestId) return null

  const clientRequestId =
    typeof payload.clientRequestId === 'string' ? payload.clientRequestId.trim() : undefined
  const tenantId = typeof payload.tenantId === 'string' ? payload.tenantId.trim() : undefined
  const tempConversationId =
    typeof payload.tempConversationId === 'string' ? payload.tempConversationId.trim() : undefined

  const conversationId =
    typeof payload.conversationId === 'string' ? payload.conversationId.trim() : ''
  if (!conversationId) return null

  const label = typeof payload.label === 'string' ? payload.label.trim() : ''
  if (!label) return null

  let timestamp: Date | null = null
  if (payload.timestamp !== undefined && payload.timestamp !== null) {
    const parsedTimestamp = new Date(payload.timestamp as string | number)
    if (!Number.isNaN(parsedTimestamp.getTime())) {
      timestamp = parsedTimestamp
    }
  }

  return {
    type: 'agent_status',
    requestId,
    clientRequestId: clientRequestId || undefined,
    tenantId: tenantId || undefined,
    tempConversationId: tempConversationId || undefined,
    conversationId,
    label,
    phase: typeof payload.phase === 'string' ? payload.phase : '',
    agent: typeof payload.agent === 'string' ? payload.agent : '',
    timestamp,
  }
}
